/**
 * PlayerControls Component
 * Audio playback controls for the subtitle editor
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import './PlayerControls.css';

interface PlayerControlsProps {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  onPlayPause: () => void;
  onSeek: (time: number) => void;
}

const PlayerControls: React.FC<PlayerControlsProps> = ({
  isPlaying,
  currentTime,
  duration,
  onPlayPause,
  // onSeek - Timeline removed, seeking done via waveform
}) => {
  const { t } = useTranslation(['subtitle']);

  // Format time display
  const formatTime = (seconds: number): string => {
    if (!seconds || !isFinite(seconds)) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="player-controls">
      <div className="controls-row">
        {/* Play/Pause Button */}
        <button
          className="control-btn play-pause-btn"
          onClick={onPlayPause}
          title={isPlaying ? t('subtitle:player.pause') : t('subtitle:player.play')}
        >
          {isPlaying ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          )}
        </button>

        {/* Time Display */}
        <div className="time-display">
          {formatTime(currentTime)} / {formatTime(duration)}
        </div>
      </div>
    </div>
  );
};

export default PlayerControls;
